module.exports = __webpack_public_path__ + "img/somosnext.a800e257.png";